package ui.styles

import emotion.css.ClassName
import emotion.css.keyframes
import web.cssom.*

object ToastStyles{
    val toasts = ClassName(ClassName("toasts")){

    }

    val toast = ClassName(ClassName("toast")){

    }

    val toastMessage = ClassName(ClassName("toast_message")){

    }


    val toastAnimation = ClassName{//todo через fun

        animation = createAnimation(3000)
    }

}

private fun createAnimation(
    duration: Int
):Animation{

    val animNameFadeIn = keyframes {
        this.from {
            this.bottom = 0.px
            this.opacity = number(0.0)
            this.visibility = Visibility.visible
        }
        this.to {
            this.bottom = 5.pct
            this.opacity = number(1.0)
            this.visibility = Visibility.visible
        }
    }

    val animNameFadeOut = keyframes {
        this.from {
            this.bottom = 5.pct
            this.opacity = number(1.0)
            this.visibility = Visibility.visible
        }
        this.to {
            this.visibility = Visibility.hidden
            this.bottom = 0.px
            this.opacity = number(0.0)
        }
    }

    val exitAnim : Animation = array(
        animNameFadeIn,
        string("0.5s, "),
        animNameFadeOut,
        string("0.5s"),
        string("${(duration + 500) / 1000}s")
    ).unsafeCast<Animation>()

    return exitAnim
}